export default {
  CLOSE_ALERT: {
    pt: 'fechar alerta',
    en: 'close alert',
    es: 'cerrar alerta',
  },
  USER_AVATAR: {
    pt: 'avatar do usuário',
    en: 'user avatar',
    es: 'avatar del usuario',
  },
  BREADCRUMB: {
    pt: 'navegação',
    en: 'breadcrumb',
    es: 'navegación',
  },
  BREADCRUMB_HOME: {
    pt: 'ir para página inicial',
    en: 'go to home page',
    es: 'ir a la página de inicio',
  },
  CLEAR: {
    pt: 'limpar',
    en: 'clear',
    es: 'limpiar',
  },
  VIEW: {
    pt: 'ver',
    en: 'view',
    es: 'ver',
  },
  COLLAPSE_ALERT: {
    pt: 'recolher alerta',
    en: 'collapse alert',
    es: 'recopilar alerta',
  },
  EXPAND_ALERT: {
    pt: 'expandir alerta',
    en: 'expand alert',
    es: 'expandir alerta',
  },
  LOADING: {
    pt: 'carregando',
    en: 'loading',
    es: 'cargando',
  },
  CAROUSEL_INDICATOR: {
    pt: 'ir para slide {0}',
    en: 'go to slide {0}',
    es: 'ir a la diapositiva {0}',
  },
  CAROUSEL_PREV_BUTTON: {
    pt: 'botão de slide anterior',
    en: 'previous slide button',
    es: 'botón de diapositiva anterior',
  },
  CAROUSEL_NEXT_BUTTON: {
    pt: 'botão de slide próximo',
    en: 'next slide button',
    es: 'botón de diapositiva siguiente',
  },
  SELECT_ALL_BUTTON_LABEL: {
    pt: 'Selecionar todos',
    en: 'Select all',
    es: 'Seleccionar todos',
  },
  EMPTY_PLACEHOLDER: {
    pt: 'Vazio',
    en: 'Empty',
    es: 'Vacío',
  },
};
